import ProjectItemList from "../components/project-item-list/Project-item-list";

const Projects = () => {
  return <ProjectItemList reversed={true}/>;
};

export default Projects;